import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const ItemSearchParamsSchema = z
  .object({
    q: z.string().optional(),
    category: z.string().nullish(),
    type: z.string().nullish(),
  })
  .merge(BasePaginateParamsSchema)

export type ItemSearchParams = z.infer<typeof ItemSearchParamsSchema>

export const ItemSearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  canBePurchased: z.boolean(),
  canBeManufactured: z.boolean(),
  canBeUsedInBom: z.boolean(),
  canBeSold: z.boolean(),
  isMoldTracking: z.boolean(),
  isLotTracking: z.boolean(),
  unit: z.string(),
  type: z.string().nullable(),
  category: z.string().nullable(),
})

export type ItemSearchResultModel = z.infer<typeof ItemSearchResultModelSchema>

export const ItemSearchResultSchema = z
  .object({
    data: z.array(ItemSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type ItemSearchResult = z.infer<typeof ItemSearchResultSchema>

// ======================== Select options ========================

export const ItemSelectOptionModelSchema =
  ItemSearchResultModelSchema.transform((data) => ({
    ...data,
    get label() {
      return `${data.code} ${data.name}`
    },
    get value() {
      return data.id.toString()
    },
  }))

export type ItemSelectOptionModel = z.infer<typeof ItemSelectOptionModelSchema>

export const ItemSelectOptionResultSchema = z
  .object({
    data: z.array(ItemSelectOptionModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type ItemSelectOptionResult = z.infer<
  typeof ItemSelectOptionResultSchema
>
